//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import DateTimeField from '../../../../components/Field/DateTimeField.vue'
import { date } from 'quasar'
import { createFieldConfig } from '../../../../components/QSelectUtils.js'
import { axiosGet } from '../../../../axios/axios.js'
import { formatConfiguredTime } from '../../../../components/helpers.js'
import ItemsSearchField from '../../../../components/Field/ItemsSearchField.vue'

export default {
  components: {
    DateTimeField,
    ItemsSearchField
  },
  props: {
    workShift: {
      type: Object,
      default () {
        return {}
      }
    },
    workShifts: {
      type: Array,
      default () {
        return []
      }
    },
    getPreviousWorkShift: {
      type: Function,
      default: () => {}
    },
    date: {
      type: Number,
      default: null
    },
    isAdditional: {
      type: Boolean,
      default: false
    },
    office: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,
      workShiftFieldConfig: createFieldConfig({ allRecordsFn: this.getMatchedWorkShifts })
    }
  },
  computed: {
    readonly: function () {
      return !this.$d_hasOperation('changeEmployeeSchedule')
    }
  },
  watch: {
    'workShift.key': {
      handler: function () {
        if (this.workShift && this.workShift.key) {
          const date = this.workShift.date || this.date

          const start = new Date(date)
          start.setHours(this.workShift.startHour)
          this.workShift.start = start.getTime()

          const end = new Date(date)
          end.setDate(end.getDate() + Math.floor(this.workShift.endHour / 24))
          end.setHours(this.workShift.endHour % 24)
          this.workShift.end = end.getTime()
        } else {
          this.workShift.start = null
          this.workShift.end = null
        }
      },
      immediate: true
    }
  },
  created: async function () {
    // Чтобы подставить подходящую доп смену
    if (this.isAdditional && (!this.workShift || !this.workShift.key)) {
      await this.getMatchedWorkShifts()
    }
  },
  methods: {
    getMatchedWorkShifts: function () {
      let workShifts = this.workShifts.map(workShift => {
        const dateAlias = workShift.date ? formatConfiguredTime(workShift.date, { month: true, date: true }) : ''

        return {
          id: workShift.key,
          name: workShift.name,
          startHour: workShift.startHour,
          endHour: workShift.endHour,
          date: this.date,
          dateAlias: dateAlias,
          _disabled: workShift._disabled
        }
      })

      if (!this.isAdditional) {
        return Promise.resolve(workShifts)
      }

      const params = new URLSearchParams()
      const lastWorkShift = this.getPreviousWorkShift(this.workShift)
      if (lastWorkShift && lastWorkShift.workShift && lastWorkShift.date && lastWorkShift.workShift !== 'brigadier.custom') {
        params.append('workShift', lastWorkShift.workShift)
        params.append('date', lastWorkShift.date)
      } else if (lastWorkShift && lastWorkShift.id) {
        params.append('id', lastWorkShift.id)
      } else {
        return Promise.resolve(workShifts.filter(wS => wS.id !== 'brigadier.custom'))
      }

      if (this.office) {
        params.append('office', 'true')
      }

      this.loading = true

      return axiosGet({
        url: '/service/delta/workday/getMatchedWorkShifts?' + params.toString(),
        onSuccess: (response) => {
          const matchedWorkShifts = response.data.map(workShift => {
            const workShiftId = workShift.workShift
            const workShiftName = workShift.workShiftAlias
            const workShiftDate = workShift.date

            const workShiftConfig = this.workShifts.find(ws => ws.key === workShiftId)
            const dateAlias = formatConfiguredTime(workShiftDate, { month: true, date: true })

            return {
              id: workShiftId,
              name: workShiftName,
              startHour: workShiftConfig.startHour,
              endHour: workShiftConfig.endHour,
              date: workShiftDate,
              dateAlias: dateAlias,
              isDefault: workShift.isDefault
            }
          })

          if (matchedWorkShifts && matchedWorkShifts.length) {
            workShifts = matchedWorkShifts
          }

          workShifts.sort((a, b) => Number(b.isDefault) - Number(a.isDefault))

          if (!this.workShift || !this.workShift.key && workShifts.length && workShifts[0].isDefault) {
            this.onSelectWorkShift(workShifts[0])
          }

          return workShifts
        },
        onFailure: 'Ошибка загрузки смен'
      }).finally(() => {
        this.loading = false
      })
    },
    dateToQuasarStr: function (d) {
      return date.formatDate(d, 'YYYY/MM/DD')
    },
    getHours: function (d) {
      return new Date(d).getHours()
    },
    onSelectWorkShift: function (selectedWorkShift) {
      if (selectedWorkShift) {
        this.workShift.key = selectedWorkShift.id
        this.workShift.name = selectedWorkShift.name
        this.workShift.startHour = selectedWorkShift.startHour
        this.workShift.endHour = selectedWorkShift.endHour
        this.workShift.date = selectedWorkShift.date
      }
    }
  }
}

